import { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'
import isLoyaltyProductTypeBonusApplicable from 'loyalty/lib/pointsCalculation/isLoyaltyProductTypeBonusApplicable'

type Payload = paths['/api/lux-loyalty/points/calculate-earn']['post']['parameters']['body']['payload']
type Response = paths['/api/lux-loyalty/points/calculate-earn']['post']['responses']['200']['content']['application/json']

function isCalculationRequestWithBonus(request: App.LoyaltyPointsEarnCalculationRequest): request is App.LoyaltyPointsEarnCalculationRequestWithBonus {
  return isLoyaltyProductTypeBonusApplicable(request.loyaltyProductType)
}

function loyaltyServerProductDetailsMap(options: App.LoyaltyPointsEarnCalculationRequest): Payload['productDetails'] {
  if (isCalculationRequestWithBonus(options)) {
    return {
      loyaltyProductType: options.loyaltyProductType,
      offerId: options.offerId,
      packageId: options.packageId,
      earnKey: options.earnKey,
      promoKey: options.promoKey,
    }
  }

  return {
    loyaltyProductType: options.loyaltyProductType,
    promoKey: options.promoKey,
  }
}

interface Options {
  customerId: string
  currency: string
  luxPlusMember: boolean
}

async function requestLoyaltyEarnPointsCalculation(request: App.LoyaltyPointsEarnCalculationRequest, options: Options): Promise<App.LoyaltyPointsEarnCalculation> {
  const payload: Payload = {
    publicPrice: request.price,
    luxPlusPrice: request.memberPrice,
    luxPlusMember: options.luxPlusMember,
    currency: options.currency,
    mx: request.mx,
    customerId: options.customerId,
    productDetails: loyaltyServerProductDetailsMap(request),
  }

  const response = await requestUtils.post<Response, Payload>('/api/lux-loyalty/points/calculate-earn',
    payload,
    { credentials: 'include' },
  )

  const basePoints = response.result.totalBasePoints
  const bonusPoints = response.result.totalBonusPoints
  const statusCredits = response.result.totalStatusCredits
  const appliedRuleIds = response.result.appliedCustomRuleIds

  return {
    request,
    points: basePoints + bonusPoints,
    basePoints,
    bonusPoints,
    statusCredits,
    appliedRuleIds,
    roundingEnabled: response.result.roundingEnabled,
    roundedPointsEarnRatio: response.result.totalPointsEarnRatio,
  }
}

export default requestLoyaltyEarnPointsCalculation
